import { Controller } from "@hotwired/stimulus"

// Dynamically adds share rows to a resource form using nested attributes.
export default class extends Controller {
  static targets = ["template", "list"]

  add() {
    const index = Date.now()
    const html = this.templateTarget.innerHTML.replace(/NEW_INDEX/g, index)
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.currentTarget.closest("[data-share-row]").remove()
  }
}
